import React from "react";
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';

import Tickets from "../TicketsCustom"
import TicketAdvanced from "../TicketsAdvanced";
import PageTitle from "../../components/PageTitle";
import { i18n } from "../../translate/i18n";

function TicketResponsiveContainer (props) {
    return (
        <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
            <div style={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
                {isWidthUp('md', props.width) ? <Tickets /> : <TicketAdvanced />}
            </div>
        </div>
    );
}

export default withWidth()(TicketResponsiveContainer);